import { configureStore, Middleware } from "@reduxjs/toolkit";

import blogReducer from "./states/blogSlice";
import viewerReducer from "./states/viewerSlice";
import debug from "./lib/debug";

const debugLogger: Middleware = (_store) => (next) => (action: any) => {
  debug.log("redux", `${action.type}`, action.payload ?? "");
  return next(action);
};

const store = configureStore({
  reducer: {
    viewer: viewerReducer,
    blog: blogReducer,
  },
  middleware: (getDefault) => getDefault().concat(debugLogger),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
